// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__25Dh2","alertIcon":"ConfirmModal_alertIcon__CkRGS"};